import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";
import moment from "moment";
import FilterRadios from "../../filter/FilterRadios";
import { Box } from "@mui/material";

const expires: { label: string; value: string }[] = [
  {
    label: "Tất cả",
    value: "all",
  },
  {
    label: "Còn hiệu lực",
    value: "on",
  },
  {
    label: "Hết hiệu lưc",
    value: "off",
  },
  {
    label: "Chưa đến ngày",
    value: "pending",
  },
];

function FilterDmChietKhau({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    ma_chietkhau: "",
    ten_chietkhau: "",
    vat_tu: null,
    expire: "all",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.ma_chietkhau) {
      condition.ma_chietkhau = {
        $regex: filter.ma_chietkhau.trim(),
        $options: "",
      };
    }
    if (filter.ten_chietkhau) {
      condition.ten_chietkhau = {
        $regex: filter.ten_chietkhau.trim()?.split(" ").join(".*"),
        $options: "",
      };
    }
    if (filter.vat_tu) {
      condition.ma_vt = filter.vat_tu?.ma_vt;
    }
    const today = moment().startOf("days").toISOString();
    switch (filter.expire) {
      case "on":
        condition.hieu_luc_tu = { $lte: today };
        condition.hieu_luc_den = { $gte: today };
        break;
      case "off":
        condition.hieu_luc_tu = { $lt: today };
        condition.hieu_luc_den = { $lt: today };
        break;
      case "pending":
        condition.hieu_luc_tu = { $gt: today };
        condition.hieu_luc_den = { $gt: today };
        break;

      default:
        break;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <Box
        sx={{
          border: "2px solid",
          borderColor: "divider",
          borderRadius: "10px",
        }}
      >
        <FilterRadios
          title="Hiệu lực"
          values={expires}
          defaultValue={filter.expire}
          onChange={(val) => setFilter({ ...filter, expire: val })}
        />
      </Box>
      <FilterText
        direction="column"
        label="Mã CK"
        placeholder="Tìm theo mã CK"
        value={filter.ma_chietkhau}
        onSearch={(val) => setFilter({ ...filter, ma_chietkhau: val })}
      />
      <FilterText
        direction="column"
        label="Tên CK"
        placeholder="Tìm theo tên CK"
        value={filter.ten_chietkhau}
        onSearch={(val) => setFilter({ ...filter, ten_chietkhau: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Sản phẩm"
        placeholder="Chọn sản phẩm"
        selectTitle="Chọn sản phẩm"
        placeholderSearch="Tìm theo mã, tên sản phẩm"
        apiCode="dmvt"
        searchFields={["ma_vt", "ten_vt"]}
        getOptionLabel={(option) => option.ten_vt}
        checkEqual={(value, option) => value?.ma_vt === option?.ma_vt}
        value={filter.vat_tu}
        onChange={(val) => setFilter({ ...filter, vat_tu: val })}
      />
    </WrapperFilter>
  );
}

export default FilterDmChietKhau;
